import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { CoverageSummaryCard } from './CoverageSummaryCard';
import { MedicalCoverageTab } from './MedicalCoverageTab';
import { Card, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';
import { Info } from 'lucide-react';

/**
 * CoverageSummaryTabs Component
 * Wrapper for Formulary and Medical coverage summary tabs
 * Uses cached indications from parent to avoid redundant API calls
 */
export const CoverageSummaryTabs = ({
  coverageData,
  productId,
  planId,
  indications = [],
  indicationsLoading = false,
}) => {

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h3 className="text-lg font-semibold">Coverage Details</h3>
        <p className="text-sm text-muted-foreground mt-1">
          View formulary and medical benefit coverage information
        </p>
      </div>

      <Tabs defaultValue="formulary" className="space-y-4">
        <TabsList className="bg-muted flex-wrap h-auto gap-2 p-2 rounded-lg border shadow-sm">
          <TabsTrigger value="formulary" className="text-xs sm:text-sm md:text-base font-medium min-h-[44px] px-3 sm:px-4 md:px-6 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Pharmacy Benefit Summary
          </TabsTrigger>
          <TabsTrigger value="medical" className="text-xs sm:text-sm md:text-base font-medium min-h-[44px] px-3 sm:px-4 md:px-6 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Medical Benefit Summary
          </TabsTrigger>
        </TabsList>

        <TabsContent value="formulary" className="mt-6">
          <CoverageSummaryCard coverageData={coverageData} />
        </TabsContent>

        <TabsContent value="medical" className="mt-6">
          {indicationsLoading ? (
            <div className="p-6">
              <Skeleton className="h-64 w-full" />
            </div>
          ) : (
            <MedicalCoverageTab
              indications={indications}
              productId={productId}
              planId={planId}
              drug={coverageData?.drug}
              cachedData={coverageData?.medicalCoverageCache || {}}
              onCacheUpdate={coverageData?.onMedicalCoverageUpdate || (() => {})}
            />
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};
